import type { RouteRecordRaw } from 'vue-router';

const Payments = () => import('@/views/payments/Payments.vue');
const ContactPage = () => import('@/views/misc/ContactPage.vue');
const FAQPage = () => import('@/views/misc/FAQ.vue');
const PrivacyPolicy = () => import('@/views/misc/PrivacyPolicy.vue');
const TermsAndConditions = () => import('@/views/misc/TermsAndConditions.vue');

export const miscRoutes: RouteRecordRaw[] = [
  {
    path: '/payments',
    name: 'payments',
    component: Payments,
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactPage,
  },
  {
    path: '/privacypolicy',
    name: 'privacy',
    component: PrivacyPolicy,
  },
  {
    path: '/faq',
    name: 'faq',
    component: FAQPage,
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: TermsAndConditions,
  },
];
